export default __webpack_public_path__ + "static/media/cross-square-button.62a56061.svg";